import { Redirect } from "react-router-dom"
import React, { Component } from 'react';
import { createUserManager } from 'redux-oidc';
import logo from './../assets/img/AgriX_Logo.png';
import user from './../assets/img/user.jpg';
import config from "react-global-configuration";
import $ from 'jquery';
import { Permission } from '../utils/Permission';
import { AESDecryption, AESEncryption } from '../utils/AesUtil';
import { Link } from 'react-router-dom';
import { Scrollbars } from 'react-custom-scrollbars';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { props } from 'bluebird';
import tokenDecoder from './Common/tokenDecoder'
//import Tooltip from '@material-ui/core/Tooltip';
import jQuery from 'jquery'
window.jQuery = $;
window.$ = $;
global.jQuery = $;
const bootstrap = require('bootstrap');
var serviceUrl = config.get('apidomain');
var idetityServiceUrl = config.get('identityDomain');
var reactWebUrl = config.get('reactDomain');
var identityUrl = config.get('identityDomain');
const screenId = 55;

export class Header extends Component {
    displayName = Header.name

    state = {
        config: {
            authority: idetityServiceUrl,
            client_id: "js",
            redirect_uri: reactWebUrl + "/callback",
            response_type: "id_token token",
            scope: "openid profile api1",
            post_logout_redirect_uri: reactWebUrl + "/signout-callback-oidc",
        },
        userName: '',
        passwordChangeDisabled: true
    }

    componentWillMount() {
        this.jqueryScripts();
    }

    resetPasswordHandler = () => {
        const username = JSON.parse(window.sessionStorage["oidc.user:" + idetityServiceUrl + ":js"]).profile.name;
        window.location.replace(idetityServiceUrl + "/Account/ResetPassword?username=" + username + "&code=" + window.access_token);
    }

    logoutHandler = () => {
        window.logout.logout();
    }

    jqueryScripts = () => {
        $(document).ready(function () {
            $(".link").click(function () {
                $('.dropdown-menu').fadeOut(100);
                $('.card').trigger('click');
                $('.dropdown').removeClass('active');
                //$('.nav-item').removeClass('active');
                $(this).closest('li').addClass('active');

            });




            $(".admin .link").click(function () {
                $('.subcard').hide();
                $('.subproduct').hide();
                $('.subadmin').show(100);
            });
            $(".product .link").click(function () {
                $('.subcard').hide();
                $('.subadmin').hide();
                $('.subproduct').show(100);
            });
            $(".cardm .link").click(function () {
                $('.subadmin').hide();
                $('.subproduct').hide();
                $('.subcard').show(100);
            });


            $(".MuiSelect-select").click(function () {
                document.body.style.overflow = "hidden";
            });

            $(".close").click(function () {
                $('.dropdown-menu').fadeOut(100);
                $('.card').trigger('click');
            });

            $(".dropdown").hover(function () {
                $('.dropdown-menu').fadeIn(500);
                //$('.dropdown').removeClass('active');
            });
            // $('.dropdown').bind('mouseout', function () {
            // $("").mouseout(function () {
            //  $('.dropdown-menu').fadeOut(500);
            //  });

            $("#menu-toggle").click(function () {
                $("#side").toggleClass('res-sidebar');
                $(".closeicon").show();
                //$("#cbp-spmenu-s1").toggleClass("menu-open");closeicon
            });
            $(".closeicon").click(function () {

                $("#side").toggleClass('res-sidebar');
                $(".closeicon").hide();
                //$("#cbp-spmenu-s1").toggleClass("menu-open");closeicon
            });
            var $window = $(window),
                $html = $('html');

            $window.resize(function resize() {
                if ($window.width() > 514) {
                    $("#side").removeClass('res-sidebar');
                    $(".closeicon").hide();
                }


            })
            $(window).resize(function () {
                if ($(window).width() >= 980) {


                    // when you hover a toggle show its dropdown menu
                    $(".navbar .dropdown-toggle").hover(function () {
                        $(this).parent().toggleClass("show");
                        $(this).parent().find(".dropdown-menu").toggleClass("show");
                    });

                    // hide the menu when the mouse leaves the dropdown
                    $(".navbar .dropdown-menu").mouseleave(function () {
                        $(this).removeClass("show");
                    });



                    // do something here
                }
            });
            $("#navbarDropdownMenuLink").click(function () {
                $("#mmenu").toggleClass('mshow');

            });
            $(".sub").click(function () {
                $(".sub").removeClass("subactive");
                $(this).addClass("subactive");
            });

            $(".link").click(function () {
                $(".sub").removeClass("subactive");
                var label = $(this).attr("aria-label");
                if (label == "group") {
                    $('.a1').addClass("subactive");
                }
                if (label == "factories") {
                    $('.a2').addClass("subactive");
                }
                if (label == "routes") {
                    $('.a3').addClass("subactive");
                }
                if (label == "estates") {
                    $('.a4').addClass("subactive");
                }
                if (label == "operationcards") {
                    $('.a5').addClass("subactive");
                }
                if (label == "division") {
                    $('.a6').addClass("subactive");
                }
                if (label == "users") {
                    $('.a7').addClass("subactive");
                }

                if (label == "packagecreation") {
                    $('.a8').addClass("subactive");
                }
                if (label == "SOS") {
                    $('.a9').addClass("subactive");
                }
                if (label == "EOS") {
                    $('.a10').addClass("subactive");
                }
                if (label == "deduction") {
                    $('.a11').addClass("subactive");
                }
                if (label == "tasktemplate") {
                    $('.a12').addClass("subactive");
                }
                if (label == "employeetaskdetails") {
                    $('.a13').addClass("subactive");
                }

                if (label == "operationcards") {
                    $('.a14').addClass("subactive");
                }
                if (label == "cardupload") {
                    $('.a15').addClass("subactive");
                }
                if (label == "employeecardupload") {
                    $('.a15').addClass("subactive")
                }
            });

        });
    }


    getUserName = () => {
        var obj = sessionStorage.getItem('TipsUser');
        var decryptedUser = AESDecryption(obj)

        var user = JSON.parse(decryptedUser);

        this.setState({ userName: user.userName });
        //return user.userName;
    }

    handleChangePassword(users) {
       props.history.push({
            pathname: 'users/userPasswordChange',
            data: users,
            edit: true
        })
    }

    getTokenName(){
        return tokenDecoder.getUserNameFromToken();
    }
    render() {
        //let userName = this.getUserName();
        return (
            <header id="topnav">

                <nav class="navbar navbar-expand-lg navbar-dark bg-primary">
                    <div class="logo">

                        <a href="index.html" class="logo">

                            <img src={logo} alt="" class="logo-large" />
                        </a>

                    </div>
                    <div class="container-fluid">
                        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                            <span class="navbar-toggler-icon"></span>
                        </button>

                        <div class="collapse navbar-collapse" id="navbarSupportedContent">
                            <ul class="navbar-nav mr-auto">

                                <li class="nav-item dropdown admin">
                                    <a class="nav-link dropdown-toggle " href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Administration
        </a>

                                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                                        <button type="button" class="close">&times;</button>
                                        <Scrollbars style={{ height: 395, color: '#fff' }}
                                            renderTrackHorizontal={props => <div {...props} className="track-horizontal" style={{ display: "none" }} />}
                                            renderThumbHorizontal={props => <div {...props} className="thumb-horizontal" style={{ display: "none" }} />}
                                            renderThumbVertical={props => <div {...props} className="thumb-horizontal" style={{ background: "#fff" }} />}

                                        >
                                            <div class="container">

                                                <div>

                                                    <div class="row">
                                                        <div class="col-md-4">

                                                            <Link to="/Groups" aria-label="group" className="link">
                                                                <i className="icon-people micon"></i><br /><br />
                                                                <p className="mtext"> Group </p>
                                                                <p className="menutext">
                                                                    Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p> 
                                                            </Link>

                                                        </div>
                                                        <div class="col-md-4">

                                                            <Link to="/Factories" aria-label="factories" className="link">
                                                                <span className="icon-home micon"></span><br /><br />
                                                                <p className="mtext"> Factory </p>
                                                                <p className="menutext">
                                                                    Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                            </Link>

                                                        </div>
                                                        <div class="col-md-4">

                                                            <Link to="/estates" aria-label="estates" className="link a4">
                                                                <span className="icon-picture micon"></span><br /><br />
                                                                <p className="mtext"> Estate </p>
                                                                <p className="menutext">
                                                                    Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                                </p>
                                                            </Link>

                                                        </div>
                                                        <div class="col-md-4">
                                                            <Link to="/routes" aria-label="routes" className="link a3">

                                                                <span className="icon-direction micon"></span><br /><br />
                                                                <p className="mtext"> Route </p>
                                                                <p className="menutext">
                                                                    Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                                </p>
                                                            </Link>

                                                        </div>
                                                        <div class="col-md-4">

                                                            <Link to="/division" aria-label="division" className="link a6">
                                                                <span className="icon-map micon"></span><br /><br />
                                                                <p className="mtext"> Division </p>
                                                                <p className="menutext">
                                                                    Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                            </Link>

                                                        </div>
                                                        <div class="col-md-4">

                                                            <Link to="/field" aria-label="field" className="link a6">
                                                                <span className="icon-map micon"></span><br /><br />
                                                                <p className="mtext"> Field </p>
                                                                <p className="menutext">
                                                                    Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                            </Link>

                                                        </div>

                                                        <div class="col-md-4">

                                                            <Link to="/operationcards" aria-label="operationcards" className="link a5">
                                                                <span className="icon-credit-card micon"></span><br /><br />
                                                                <p className="mtext"> Operation Card </p>
                                                                <p className="menutext">
                                                                    Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                            </Link>

                                                        </div>

                                                        <div class="col-md-4">

                                                            <Link to="/users" aria-label="users" className="link a7">
                                                                <span className="icon-people micon"></span><br /><br />
                                                                <p className="mtext"> Users </p>
                                                                <p className="menutext">
                                                                    Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                            </Link>

                                                        </div>

                                                        <div class="col-md-4">

                                                            <Link to="/factoryitems" aria-label="users" className="link a7">
                                                                <span className="icon-people micon"></span><br /><br />
                                                                <p className="mtext"> Factory Items </p>
                                                                <p className="menutext">
                                                                    Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                            </Link>

                                                        </div>
                                                        <div class="col-md-4">

                                                            <Link to="/opproductmapping" aria-label="users" className="link a7">
                                                                <span className="icon-people micon"></span><br /><br />
                                                                <p className="mtext"> Product to Operation Entity </p>
                                                                <p className="menutext">
                                                                    Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                            </Link>

                                                        </div>
                                                        <div class="col-md-4">

                                                            <Link to="/opcollectioncatagorymapping" aria-label="users" className="link a7">
                                                                <span className="icon-people micon"></span><br /><br />
                                                                <p className="mtext"> Operation Entity to Collection Category </p>
                                                                <p className="menutext">
                                                                    Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                            </Link>

                                                        </div>

                                                        <div class="col-md-4">

                                                            <Link to="/MobileMenu" aria-label="users" className="link a7">
                                                                <span className="icon-people micon"></span><br /><br />
                                                                <p className="mtext"> Mobile Menu </p>
                                                                <p className="menutext">
                                                                    Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                            </Link>

                                                        </div>

                                                        <div class="col-md-4">

                                                            <Link to="/Customer" aria-label="users" className="link a7">
                                                                <span className="icon-people micon"></span><br /><br />
                                                                <p className="mtext"> Customer</p>
                                                                <p className="menutext">
                                                                    Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                            </Link>

                                                        </div>

                                                        <div class="col-md-4">

                                                            <Link to="/collectioncategorytypemapping" aria-label="users" className="link a7">
                                                                <span className="icon-people micon"></span><br /><br />
                                                                <p className="mtext"> Collection Category Collection Type </p>
                                                                <p className="menutext">
                                                                    Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                            </Link>



                                                        </div>

                                                        <div class="col-md-4">

                                                            <Link to="/collectiontype" aria-label="users" className="link a7">
                                                                <span className="icon-people micon"></span><br /><br />
                                                                <p className="mtext"> Collection Type </p>
                                                                <p className="menutext">
                                                                    Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                            </Link>



                                                        </div>
                                                        <div class="col-md-4">

                                                            <Link to="/role" aria-label="users" className="link a7">
                                                            <span className="icon-people micon"></span><br /><br />
                                                            <p className="mtext"> Role </p>
                                                            <p className="menutext">
                                                                Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                        </Link>

                                                    </div>


                                                        <div class="col-md-4">

                                                            <Link to="/mobilemenucollectioncategorytypemapping" aria-label="users" className="link a7">
                                                                <span className="icon-people micon"></span><br /><br />
                                                                <p className="mtext"> Mobile menu Collection Category</p>
                                                                <p className="menutext">
                                                                    Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                            </Link>

                                                        </div>
                                                        <div class="col-md-4">

                                                            <Link to="/products" aria-label="users" className="link a7">
                                                                <span className="icon-people micon"></span><br /><br />
                                                                <p className="mtext"> Product </p>
                                                                <p className="menutext">
                                                                    Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                            </Link>

                                                        </div>
                                                        <div class="col-md-4">

                                                            <Link to="/CollectionCategoryMaster" aria-label="users" className="link a7">
                                                                <span className="icon-people micon"></span><br /><br />
                                                                <p className="mtext"> Collection Category </p>
                                                                <p className="menutext">
                                                                    Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                            </Link>

                                                        </div>
                                                        <div class="col-md-4">

                                                            <Link to="/factoryweightpoint" aria-label="users" className="link a7">
                                                                <span className="icon-people micon"></span><br /><br />
                                                                <p className="mtext"> Factory Weight Point </p>
                                                                <p className="menutext">
                                                                    Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                            </Link>

                                                        </div>

                                                        <div class="col-md-4">

                                                            <Link to="/factoryitemrequestapproval" aria-label="users" className="link a7">
                                                                <span className="icon-people micon"></span><br /><br />
                                                                <p className="mtext"> Factory Item Request Approval </p>
                                                                <p className="menutext">
                                                                    Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                            </Link>

                                                        </div>
                                                    </div>




                                                </div>

                                            </div>
                                        </Scrollbars>



                                    </div>
                                </li>

                                <li class="nav-item dropdown product">
                                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Product Operations
        </a>
                                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">


                                        <div class="container">
                                            <div class="row">
                                                <div class="col-md-4">

                                                    <Link to="/packagecreation" aria-label="packagecreation" className="link">
                                                        <span className="icon-briefcase micon"></span><br /><br />
                                                        <p className="mtext"> Packages </p>
                                                        <p className="menutext">
                                                            Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                    </p>
                                                    </Link>

                                                </div>
                                                <div class="col-md-4">

                                                    <Link to="/SOS" aria-label="SOS" className="link">
                                                        <span className="icon-folder-alt micon"></span><br /><br />
                                                        <p className="mtext"> SOS </p>
                                                        <p className="menutext">
                                                            Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                    </Link>

                                                </div>
                                                <div class="col-md-4">
                                                    <Link to="/EOS" aria-label="EOS" className="link">
                                                        <span className="icon-folder micon"></span><br /><br />
                                                        <p className="mtext"> EOS </p>
                                                        <p className="menutext">
                                                            Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                    </Link>

                                                </div>
                                                <div class="col-md-4">
                                                    <Link to="/deduction" aria-label="deduction" className="link">
                                                        <span className="icon-logout micon"></span><br /><br />
                                                        <p className="mtext"> Deduction Template </p>
                                                        <p className="menutext">
                                                            Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                    </Link>
                                                </div>
                                                <div class="col-md-4">
                                                    <Link to="/tasktemplate" aria-label="tasktemplate" className="link">
                                                        <span className="icon-target micon"></span><br /><br />
                                                        <p className="mtext"> Task Template </p>
                                                        <p className="menutext">
                                                            Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                    </Link>
                                                </div>
                                                <div class="col-md-4">
                                                    <Link to="/task" aria-label="task" className="link">
                                                        <span className="icon-target micon"></span><br /><br />
                                                        <p className="mtext"> Estate Task </p>
                                                        <p className="menutext">
                                                            Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                    </Link>
                                                </div>
                                                <div class="col-md-4">

                                                    <Link to="/GPS" aria-label="GPS Maps" className="link">
                                                        <span className="icon-map micon"></span><br /><br />
                                                        <p className="mtext"> GPS Maps </p>
                                                        <p className="menutext">
                                                            Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                    </Link>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>

                                <li class="nav-item dropdown cardm">
                                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Card Management
        </a>
                                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">


                                        <div class="container">
                                            <div class="row">
                                                <div class="col-md-4">

                                                    <Link to="/operationcards" aria-label="operationcards" className="link">
                                                        <span className="icon-credit-card micon"></span><br /><br />
                                                        <p className="mtext"> Operation Card </p>
                                                        <p className="menutext">
                                                            Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                    </Link>

                                                </div>
                                                <div class="col-md-4">

                                                    <Link to="/cardupload" aria-label="cardupload" className="link">
                                                        <span className="icon-cloud-upload micon"></span><br /><br />
                                                        <p className="mtext"> Card Upload </p>
                                                        <p className="menutext">
                                                            Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>



                                    </div>
                                </li>
                                <li class="nav-item dropdown">
                                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Reports
        </a>
                                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">


                                        <div class="container">
                                            <div class="row">
                                                <div class="col-md-4">

                                                    <Link to="/DailyCollectionSummeryReport" aria-label="cardupload" className="link">
                                                        <span className="icon-cloud-upload micon"></span><br /><br />
                                                        <p className="mtext"> Daily Collection Summery Report </p>
                                                        <p className="menutext">
                                                            Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                    </Link>

                                                </div>
                                                <div class="col-md-4">

                                                    <Link to="/DailyCollectionReport" aria-label="cardupload" className="link">
                                                        <span className="icon-cloud-upload micon"></span><br /><br />
                                                        <p className="mtext"> Daily Collection Report </p>
                                                        <p className="menutext">
                                                            Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                    </Link>

                                                </div>
                                                <div class="col-md-4">
                                                    <Link to="/CollectionpointMonthlyDetailReport" aria-label="cardupload" className="link">
                                                        <span className="icon-cloud-upload micon"></span><br /><br />
                                                        <p className="mtext"> Collectionpoint Monthly Detail Report </p>
                                                        <p className="menutext">
                                                            Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                    </Link>

                                                </div>

                                              
                                                <div class="col-md-4">

                                                    <a href="">
                                                        <span className="icon-picture micon"></span><br /><br />
                                                        <p className="mtext"> Estate </p>
                                                        <p className="menutext">
                                                            Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                    </a>

                                                </div>
                                                <div class="col-md-4">

                                                    <a href="">
                                                        <span className="icon-credit-card micon"></span><br /><br />
                                                        <p className="mtext"> Operation Card </p>
                                                        <p className="menutext">
                                                            Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                    </a>

                                                </div>
                                                <div class="col-md-4">

                                                    <a href="">
                                                        <span className="icon-map micon"></span><br /><br />
                                                        <p className="mtext"> Division </p>
                                                        <p className="menutext">
                                                            Without the rule, our designs are limited to the fonts that are already loaded on a user's computer, which vary depending on the system being used
                                                        </p>
                                                    </a>

                                                </div>
                                            </div>
                                        </div>



                                    </div>
                                </li>

                                <li class="nav-item">
                                    <a class="nav-link" href="#" id="navbarDropdown" role="button" aria-haspopup="true" aria-expanded="false">
                                        Help
        </a>

                                </li>

                            </ul>
                            <ul class="navbar-right d-flex list-inline float-right mb-0">



                                <li className="nav-item">
                                    <a className="nav-link dropdown-toggle" id="navbarDropdownMenuLink" data-toggle="" aria-haspopup="true" aria-expanded="true">
                                        <i className="fa fa-user"></i> {this.getTokenName()}

                                    </a>
                                    <div className="dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink" id="mmenu">
                                        <a className="dropdown-item" > <i className="now-ui-icons fa fa-user fa2x"></i> Profile</a>
                                        <a className="dropdown-item" onClick={this.logoutHandler}> <i className="now-ui-icons fa fa-power-off fa2x"></i> Logout</a>
                                        

                                        <a href ="/users/userPasswordChange"  className="dropdown-item"> <i className="now-ui-icons fa fa-user fa2x"></i> Change Password</a>

                                        
                                       
                                    </div>
                                </li>

                                <li class="menu-item list-inline-item">

                                    <a class="navbar-toggle nav-link">
                                        <div class="lines">
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </div>
                                    </a>

                                </li>

                            </ul>
                        </div>
                    </div>

                </nav>

                <div className="container-fluid">
                    <div class="icon-bar subadmin">
                        <Link to="/groups" title="Group"><i className="a1 sub icon-people micon"></i></Link>
                        <Link to="/Factories" title="Factories"><i class="a2 sub icon-home micon"></i></Link>
                        <Link to="/routes" title="Routes"><i class="a3 sub icon-direction micon"></i></Link>
                        <Link to="/estates" title="Estate"><i class="a4 sub icon-picture micon"></i></Link>
                        <Link to="/operationcards" title="Operation Cards"><i class="a5 sub icon-credit-card micon"></i></Link>
                        <Link to="/division" title="Division"><i class="a6 sub icon-map micon"></i></Link>
                        <Link to="/users" title="Users"><i class="a7 sub icon-people micon"></i></Link>
                    </div>
                    <div class="icon-bar subproduct">
                        <Link to="/packagecreation" title="Package Creation"><i className="a8 sub icon-briefcase micon"></i></Link>
                        <Link to="/SOS" title="SOS"><i class="a9 sub icon-folder-alt micon"></i></Link>
                        <Link to="/EOS" title="EOS"><i class="a10 sub icon-folder micon"></i></Link>
                        <Link to="/deduction" title="Deduction"><i class="a11 sub icon-logout micon"></i></Link>
                        <Link to="/tasktemplate" title="Task Template "><i class="a12 sub icon-target micon"></i></Link>
                    </div>
                    <div class="icon-bar subcard">
                        <Link to="/operationcards" title="Operation Cards  "><i className="a13 sub icon-credit-card micon"></i></Link>
                        <Link to="/cardupload" title="Card Upload"><i class="a14 sub icon-cloud-upload micon"></i></Link>

                    </div>
                </div>
            </header>
        );
    }
}
                
